var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from 'react';
import { isValidPhone } from '../../../utils';
import { useMessageById, useMessageModel, useMobileModel, useConsultModel } from '../../../hooks';
import { ConsultQueryName } from '@tencent/dz-models';
import { useReportService } from './useReportService';
export var useFormService = function (messageId) {
    var mobile = useMobileModel().mobile;
    var messageModel = useMessageModel();
    var consuleModel = useConsultModel();
    var messageState = useMessageById(messageId);
    var queryWord = consuleModel.isSearchConsult() ? consuleModel.getQueryParams(ConsultQueryName.Query_Word) : '';
    var _a = useState(''), name = _a[0], setName = _a[1];
    var _b = useState(''), phone = _b[0], setPhone = _b[1];
    var _c = useState(queryWord), content = _c[0], setContent = _c[1];
    var _d = useState(true), valid = _d[0], setValide = _d[1];
    var _e = useState(false), modalVisible = _e[0], setModalVisible = _e[1];
    var _f = useState(false), checked = _f[0], setChecked = _f[1];
    var payload = messageState.payload;
    var report = useReportService(__assign(__assign({}, payload.reportModuleParams), { element_id: payload.leaveMsgType }));
    var hanleNameChange = function (value) {
        setName(value);
    };
    var handlePhoneChange = function (value) {
        setValide(isValidPhone(value));
        setPhone(value);
    };
    var handleContentChange = function (e) {
        setContent(e.target.value);
    };
    var onSubmitPhone = function (checked) {
        if (!checked) {
            setModalVisible(true);
            report.formPopupExposure();
            return;
        }
        report.formAuthButtonClick();
        setChecked(true);
        setPhone(mobile);
    };
    var handleSubmit = function () {
        if (!phone || !valid) {
            !phone && setValide(false);
            return;
        }
        messageModel.sendFormMessage({
            name: name,
            phone: phone,
            content: content,
            msgType: messageState.type,
        });
        report.formSubmit({
            name: name,
            phone: phone,
            content: content,
        });
    };
    var hanldePopupOk = function () {
        setChecked(true);
        setModalVisible(false);
        setPhone(mobile);
        report.formPopupSubmit();
    };
    var hanldePopupCancel = function () {
        setModalVisible(false);
        report.formPopupCancel();
    };
    var handleToggle = function (value) {
        report.formClauseClick(value);
        setChecked(value);
    };
    return {
        name: name,
        phone: phone,
        content: content,
        modalVisible: modalVisible,
        checked: checked,
        hanleNameChange: hanleNameChange,
        handlePhoneChange: handlePhoneChange,
        handleContentChange: handleContentChange,
        onSubmitPhone: onSubmitPhone,
        handleSubmit: handleSubmit,
        valid: valid,
        hanldePopupOk: hanldePopupOk,
        hanldePopupCancel: hanldePopupCancel,
        handleToggle: handleToggle,
    };
};
